import { createRouter, createWebHistory } from 'vue-router';
import routes from '@/routes';
import { isUserAuth, isUserActive, userManager } from '@/helpers/auth';

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return new Promise(resolve => {
                setTimeout(() => {
                    resolve({ left: 0, top: savedPosition.top });
                }, 1);
            });
        // @ts-ignore-next-line
        } else if (to.meta.saveScrollPosition) {
            return { left: 0, top: window.scrollY };
        }

        return { left: 0, top: 0 };
    },
});
router.beforeEach((to: any, from: any, next: any) => {
    if (userManager() && to.name !== 'NoPermissionPage') {
        next({ name: 'NoPermissionPage' });
    } else if (to.meta.notAuthRequired) {
        if (isUserAuth()) {
            next({ name: 'CalendarViewPage' });
        } else {
            next();
        }
    } else if (!isUserActive() && to.path !== '/create-password' && to.path !== '/logout') {
        next({ name: 'CreatePassword' });
    } else if (isUserActive() && to.path === '/create-password') {
        next({ name: 'OnboardingWelcomePage' });
    } else if (!to.meta.notAuthRequired) {
        if (!isUserAuth()) {
            next({ name: 'LoginPage' });
        } else {
            next();
        }
    } else {
        next();
    }
});
export default router;
